import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc, {d3, crossfilter} from 'dc';
import CoordinateBaseChart from './coordinateBaseChart';
import * as utilFunctions from './util/utilFunctions';
 
class LineChart extends CoordinateBaseChart {
  constructor(props, context) {
    super(props, context);
    this.state = utilFunctions.mergeState(this.state, {
      config: utilFunctions.mergeState(this.state.config, {
          interpolation: "monotone",
          renderArea: false,
          dataPoints: {show:false, radius:5, toShow:"ALL", showLastLabel: false},
          trendLine: false,
          stroke: 2.7,
        }),
    }); 
    this.state.type = "LINE";
    this.state.tooltipObjectClass = ".dot";
  }

  getChartTypeInstance() {
    if(this.props.stack) {
      return dc.lineChart("#"+this.props.id);        
    }
    else {
      return dc.compositeChart("#"+this.props.id);
    }
  }

  getChartCompositeInstance() {
    return dc.lineChart(this.state.chart);
  } 

  _stylingAndFormat(chart)
  {
    chart
      .interpolate(this.state.config.interpolation)
      .renderArea(this.state.config.renderArea);
  }

  stylingAndFormat() {
    super.stylingAndFormat();
    if(this.props.stack) { 
      this.state.chart
        .renderArea(true)
        .defined(function(d){
            return (d.y !== null);
        });     
      this._stylingAndFormat(this.state.chart);
    }
    else
    {
      this.state.chart
        .childOptions({
          defined: function(d){
              return (d.y !== null);
          }
        });
      if(this.props.dimension.reduceFunction.fixes == "FIX_LINE_CHART") {
        this.state.chart._rangeBandPadding(1);
      }
      for(var i=0;i<this.state.composeCharts.length;i++) {
        this._stylingAndFormat(this.state.composeCharts[i]);
      }
    }
  }

  postRenderOperations() {
    var extraSelector = "";

    if(this.state.config.dataPoints.showLastLabel == true) {
      var dataPoints = this.state.chart.selectAll(this.state.tooltipObjectClass);
      if(dataPoints.length>0) {
        var dataPoint = dataPoints[dataPoints.length-1];
        //FALTA IMPLEMENTAR
      }
    }

    if(this.state.config.dataPoints.show == true) {
      switch(this.state.config.dataPoints.toShow ) {
        case "LAST":
          extraSelector = ':last-of-type';
          break;
        case "FIRST":
          extraSelector = ':first-of-type';
          break;
      }

      this.state.chart.svg()
        .selectAll('.dc-tooltip ' + this.state.tooltipObjectClass + extraSelector)
        .attr("r",this.state.config.dataPoints.radius)
        .classed("alwaysShowTooltip",true)
        .on("mouseout", (function(d) {     
            d3.event.target
              .setAttribute("r",this.state.config.dataPoints.radius);
            this.state.chart.svg().selectAll('.dc-tooltip .xRef')
              .style("display","none");  
            this.state.chart.svg().selectAll('.dc-tooltip .yRef')
              .style("display","none");   
        }).bind(this));
    }

    if(this.state.config.showNulls) {
      var radius = this.state.config.dataPoints.radius;
      var trendLine = this.state.config.trendLine;
      this.state.chart.svg().selectAll(this.state.tooltipObjectClass)
          .each(function(d) {
            if(d.data && d.data.value && 
              d.data.value.value == null) {
              d3.select(this)
                .style("fill", "#fff")
                .style("stroke-width", (trendLine ? 0 : 1))
                .attr("r", (trendLine ? radius : radius+1))
                .style("stroke", "#444");
            }
            else if(trendLine) {
              d3.select(this).attr("r", 0)
            }
          });
      if(trendLine) {
        this.state.chart.svg().selectAll(this.state.tooltipObjectClass + ":last-of-type")
            .each(function(d) {
              d3.select(this)
                .attr("r", radius+1)
            });        
      }
    }

    if(this.state.crossfilter.getMetrics().length==1 
      && this.props.additionalCrossfilterData != null
      && this.state.config.tooltip.show == true) {
      var metrics=this.props.additionalCrossfilterData.getMetrics();
      var extraInfo = {};
      for(var i=0;i<metrics.length;i++) {
        var results = metrics[i].all();
        for(var j=0;j<results.length;j++) {
          var key = results[j].key;
          if((key in extraInfo)==false) {
            extraInfo[key] = [];
          }
          extraInfo[key][extraInfo[key].length] = {
            name: metrics[i].name, 
            value: (this.props.additionalCrossfilterData.getValueAccesor())(results[j]),
            config: metrics[i].config
          };
        }
      }
      var tooltipsLookupObject = {};

      this.state.chart.svg().selectAll(this.state.tooltipObjectClass)
          .each(function(d) {
              tooltipsLookupObject[d.x] = {object: this, data: d};
          });

      for(var key in extraInfo) {
        if(key in tooltipsLookupObject) {
          tooltipsLookupObject[key].data.extraInfo = extraInfo[key];
          d3.select(tooltipsLookupObject[key].object)
            .attr("r", 4)
            .style("fill", "#006AAB")
            .classed("extraInfoTooltip",true)
            .data([tooltipsLookupObject[key].data]);
        }
        else {
          this.state.chart.svg().selectAll(".dc-tooltip-list")
            .append("circle")
            .attr("cx", this.state.chart.x()(key))
            .attr("cy", this.state.chart.y()(0))
            .attr("r", 4)
            .style("fill", "#006AAB")
            .attr("class", this.state.tooltipObjectClass.replace(".", "") + " alwaysShowTooltip extraInfoTooltip")
            .data([{
              extraInfo: extraInfo[key],
              x: +key,
              y: null,
              layer:null,
              data: {key:null}
            }]); 
        }   
      }
    }

    super.postRenderOperations();

    if(this.state.chart.svg().selectAll('.sub .line').empty() == false) {
      this.state.chart.svg().selectAll('.sub .line').style("stroke-width",this.state.config.stroke);
    }    

    if(this.state.crossfilter.getMetrics().length==1 && this.state.config.tooltip.show == true) {
      var widthForTooltips = this.state.chart.svg().attr("width");
      var heightForTooltips = this.state.chart.svg().attr("height");
      var toolTipsWidth = 0;

      if(this.state.config.xAxis.show == true) {
        var xAxisBox = this.state.chart.svg().selectAll("g.axis.x").node().getBBox();
        heightForTooltips-=xAxisBox.height;
      }
      if(this.state.config.yAxis.show == true) {
        var yAxisBox = this.state.chart.svg().selectAll("g.axis.y").node().getBBox();
        widthForTooltips-=yAxisBox.width;
      }
      var tooltipsNumber = this.state.chart.svg().selectAll(this.state.tooltipObjectClass).size();
      if(tooltipsNumber>0) {
        var defaultWidth = 20;
        toolTipsWidth=widthForTooltips/tooltipsNumber;
        if(toolTipsWidth>defaultWidth) {
          toolTipsWidth = defaultWidth;
        }
        var newTooltipsWrapper = d3.selectAll("#"+this.props.id + " " + "svg g.sub._0").append("g").attr("class","newTooltips");
        var transform = d3.selectAll("#"+this.props.id + " " + "svg g.sub._0 .chart-body").attr("transform"); 
        newTooltipsWrapper.attr("transform",transform);
        this.state.chart.svg().selectAll(this.state.tooltipObjectClass)
          .each(function(d) {
              var _d = d;
              var _this = this;
              var tooltipOverlay = newTooltipsWrapper.append("rect")
                .attr("height",heightForTooltips)
                .attr("width",toolTipsWidth)
                .attr("y",0)
                .attr("x",d3.select(this).attr("cx")-toolTipsWidth/2)
                .attr("class","newTooltip")
                .style("fill","transparent")
                .on("mouseover",function(){d3.select(_this).on("mouseover")(_d,d3.select(_this));})
                .on("mouseleave", function(){d3.select(_this).on("mouseleave")(_d,d3.select(_this));});

              if(d3.select(_this).classed("linkTooltip") == true) {
                tooltipOverlay.classed("linkTooltip",true);
                tooltipOverlay.on("click", function(){d3.select(_this).on("click")(_d);});
              }              
          });
      }
    }    
  }
}

export default LineChart;


// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/lineChart.jsx